// import "./Products.scss";
import SaleProduct from "./SaleProduct/SaleProduct";
// import Product from "./Product/Product";
import whatsappLogo from "../../../assets/whatsapp.jpg"
import { Link } from "react-router-dom";

const SaleProducts = ({saleProducts,innerPage,headingText}) => {
    return (
        <div className="products-container">
            {!innerPage && <div className="sec-heading">
                {headingText}
            </div>}
            <div className="products">
                {saleProducts?.data?.map((item) => (
                    <SaleProduct key={item.id} id={item.id} data={item.attributes}/>
                ))}
                
            </div>
            <div style={{width:"40px",height:"40px",position:"fixed",right:"10px",bottom:"10px",float:"right"}}>
                    <Link to="https://wa.me/919653217981">
        <img src={whatsappLogo}  style={{width:"60px", border:"1px solid white", borderRadius:"50%",cursor:"pointer" }} alt="" />
                    </Link>
                </div>
        </div>
    );
};

export default SaleProducts;
